// extracted by mini-css-extract-plugin
module.exports = {"root":"key_moment_root__AVz0r"};